import React from 'react';
import { Hero } from '../components/Hero';
import { TaglineExplainer } from '../components/TaglineExplainer';
import { ProofStrip } from '../components/ProofStrip';
import { Problem } from '../components/Problem';
import { HomeHowItWorks } from '../components/HomeHowItWorks';
import { WhatPeriscanValidates } from '../components/WhatPeriscanValidates';
import { PeriscanOperators } from '../components/PeriscanOperators';
import { Competitive } from '../components/Competitive';
import { Safety } from '../components/Safety';
import { WhyNow } from '../components/WhyNow';
import { FounderCard } from '../components/FounderCard';
import { ValidationSnapshot } from '../components/ValidationSnapshot';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { SectionStage } from '../components/SectionStage';
import { FrontierGatewayTeaser } from '../components/FrontierGatewayTeaser';
/**
 * Tighter homepage flow. Stripped of:
 *  - Cyberpunk SectionStage backdrops (matrix / lightning / hyperspeed /
 *    ripple / threads / circuit / constellation / orbs-spotlight) that
 *    read as generic AI-template "dark cyber" aesthetic.
 *  - Duplicate Positioning + Audiences blocks that restated the
 *    Solution / Operators material in a card grid.
 *  - The MidCTA card (CTA spam — the page already ends with FinalCTA).
 *
 * What's left is the structural argument:
 *   1. Brand reveal       Hero
 *   2. Receipts strip     ProofStrip
 *   3. The problem        Problem
 *   4. The answer         TaglineExplainer
 *   5. The five jobs      WhatPeriscanValidates
 *   6. How it works       HomeHowItWorks
 *   7. The operators      PeriscanOperators
 *   8. First proof moment ValidationSnapshot
 *   9. Why us vs not us   Competitive
 *  10. Trust & safety     Safety
 *  11. Brand legacy       WhyNow  (only section that keeps a backdrop — the
 *                                  radar sweep is thematic, user-requested)
 *  12. Founder            FounderCard
 *  13. FAQ                FAQ
 *  14. Final CTA          FinalCTA
 */
export function Home() {
  return <>
      <Hero data-id="element-1561" />
      <SectionStage fx="beams" data-id="element-1562">
        <ProofStrip data-id="element-1563" />
      </SectionStage>
      <SectionStage fx="matrix" data-id="element-1564">
        <Problem data-id="element-1565" />
      </SectionStage>
      <SectionStage fx="spotlight" data-id="element-1566">
        <TaglineExplainer data-id="element-1567" />
      </SectionStage>
      <SectionStage fx="circuit" data-id="element-1568">
        <WhatPeriscanValidates data-id="element-1569" />
      </SectionStage>
      <SectionStage fx="threads" data-id="element-1570">
        <HomeHowItWorks data-id="element-1571" />
      </SectionStage>
      {/* Periscan Operators — rendered without SectionStage so the cinematic
                    blur/opacity transform doesn't dampen the radar sweep behind it. */}
      <PeriscanOperators data-id="element-1572" />
      <SectionStage fx="orbit" data-id="element-1573">
        <FrontierGatewayTeaser data-id="element-1574" />
      </SectionStage>
      <SectionStage fx="ripple" data-id="element-1575">
        <ValidationSnapshot data-id="element-1576" />
      </SectionStage>
      <SectionStage fx="lightning" data-id="element-1577">
        <Competitive data-id="element-1578" />
      </SectionStage>
      <SectionStage fx="constellation" data-id="element-1579">
        <Safety data-id="element-1580" />
      </SectionStage>

      {/* Brand Legacy — rendered without SectionStage so the cinematic
                      blur/opacity transform doesn't dampen the radar sweep. */}
      <WhyNow data-id="element-1581" />

      <SectionStage fx="glow-orbs" data-id="element-1582">
        <FounderCard data-id="element-1583" />
      </SectionStage>
      <SectionStage fx="squares" data-id="element-1584">
        <FAQ data-id="element-1585" />
      </SectionStage>
      <SectionStage fx="hyperspeed-aurora" data-id="element-1586">
        <FinalCTA data-id="element-1587" />
      </SectionStage>
    </>;
}